export const windowInnerHeight = window.innerHeight;
export const windowInnerWidth = window.innerWidth;